import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { MediaBankEditBase } from '../media-bank-edit-base';
import { MediaBankFileModel } from '../media-bank-file.model';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { AccessRightFilterCollectionModel, ILightWeightObject, PublicationSettingModel } from '@fi-shared/models';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiCommentSettingType } from '@fi-shared/types';
import { FileUploadModel } from '@fi-app/utilities/file-upload/file-upload.model';
import { FiMobileAppHelperService } from '@fi-app/utilities/fi-services/mobile-app-helper.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { ObjectTitleService } from '@fi-app/utilities/fi-services/object-title.service';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { FiStateChangeService } from '@fi-shared/fi-state-proxy/fi-state-change.service';
import { FiFileUpload2Service } from '@fi-shared/fi-insert-media/fi-file-upload2.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiInsertMedia2Service } from '@fi-shared/fi-insert-media/fi-insert-media2.service';
import { removeItem } from '@fi-shared/utils/remove-item';
import { ILightWeightTag } from '@fi-shared/fi-tag2/fi-tag2';

@Component({
    selector: 'fi-media-bank-new',
    templateUrl: './media-bank-new.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['../media-bank-edit/media-bank-edit.component.scss'],
    host: { class: 'fi-media-bank-form-edit' },
    standalone: false,
})
export class MediaBankNewComponent extends MediaBankEditBase implements OnInit {
    FileUploadModel: FileUploadModel;
    MediaBankFiles: MediaBankFileModel[] = [];
    private isMultipleContentLanguages: boolean = false;
    SelectedTagsIds: number[] = [];
    AccessRightFilterCollection = new AccessRightFilterCollectionModel();
    hasRightsToAddTags: boolean = false;
    FilesSettings: {
        SendPushMessages: boolean;
        IsNews: boolean;
        CommentSettingType: FiCommentSettingType;
    };

    protected publicationSetting = PublicationSettingModel.getNewInstance();

    constructor(
        injector: Injector,
        private fiLoadingService: LoadingService,
        private saveChangesWarningService: SaveChangesWarningService,
        private insertMedia2Service: FiInsertMedia2Service,
        private fileUploadService: FiFileUpload2Service,
        private mobileAppHelperService: FiMobileAppHelperService,
        private stateService: FiStateService,
        private objectTitleService: ObjectTitleService,
        private detectDevices: DetectDevicesService,
        private stateChangeService: FiStateChangeService,
        customerDataService: FiCustomerDataService,
    ) {
        super(injector);
        this.isMultipleContentLanguages = customerDataService.customerData.ContentLanguages.length > 1;
        this.FilesSettings = {
            IsNews: customerDataService.customerData.CanShareAsNews,
            CommentSettingType: FiCommentSettingType.NoComments,
            SendPushMessages: true,
        };
    }

    ngOnInit() {
        super.onInit(this.objectTitleService.getCreateTitle(ObjectTypes.MediaBank));
        this.FileUploadModel = new FileUploadModel(($files) => {
            if (this.isMobilePhone()) this.MediaBankFiles.length = 0;

            this.fiLoadingService.trackPromise(
                this.fileUploadService.uploadFiles({
                    files: $files,
                    onUploadStarted: (uploadItem) => this.MediaBankFiles.push(<any>uploadItem.mediaBankFile),
                    onUploadError: (uploadError) => this.uploadErrors.push(uploadError),
                    skipSaveMediaBankOnBackend: true,
                    formData: {
                        contentLanguageId: this.selectedLanguageId,
                    },
                }),
            );
        });
        this.FileUploadModel.multiple = !this.isMobilePhone();

        const getModelData = () => ({
            mediaBankFiles: this.MediaBankFiles,
        });

        this.saveChangesWarningService.start(getModelData);
    }

    addNewTag(tagName: string): void {
        super.addNewTag(tagName, (tag) => {
            this.availableTags.push(tag);
            this.SelectedTagsIds = [...this.SelectedTagsIds, tag.Id];
            this.MediaBankFiles.forEach((mediaBankFileModel: MediaBankFileModel) => {
                mediaBankFileModel.TagIds.push(tag.Id);
            });
        });
    }

    isTranslationsListShown(): boolean {
        return true;
        //return this.isMultipleContentLanguages && this.MediaBankFiles.length === 1;
    }

    isMobilePhone() {
        return this.detectDevices.isMobilePhone();
    }

    EditMediaFile(mediaBankFile: MediaBankFileModel) {
        mediaBankFile.IsEditMode = !mediaBankFile.IsEditMode;
    }

    DeleteMediaFile(mediaBankFile: MediaBankFileModel) {
        removeItem(this.MediaBankFiles, mediaBankFile);

        if (mediaBankFile.Id > 0) this.mediaBankService.ForceDeleteMediaBankFile(mediaBankFile.Id);

        if (mediaBankFile.$$uploadPogress) {
            mediaBankFile.$$uploadPogress.abort();
            delete mediaBankFile.$$uploadPogress;
        }
    }

    Save() {
        const mediaBankFilesToSave = this.MediaBankFiles.filter((item) => !this.getReasonCode(item));

        const fileNotUploadCompleted = mediaBankFilesToSave.find((mediaBankFile) => {
            return (
                mediaBankFile.PercentageLoaded &&
                mediaBankFile.PercentageLoaded < 100 &&
                mediaBankFile.PercentageProcessed < 100
            );
        });
        if (fileNotUploadCompleted) {
            this.fiDialogsService.notify({
                messageText: this.appTextService.get('media_bank.save_error_upload_not_complete'),
            });
            return;
        }

        if (mediaBankFilesToSave.length) {
            mediaBankFilesToSave.forEach((mediaBankFile) => {
                mediaBankFile.MediaBankFileSetting.IsNews = this.FilesSettings.IsNews;
                mediaBankFile.MediaBankFileSetting.SendPushMessages = this.FilesSettings.SendPushMessages;
                /*
                                mediaBankFile.MediaBankFileSetting.IsSmsNotification = this.FilesSettings.IsSmsNotification;
                                mediaBankFile.MediaBankFileSetting.IsEmailNotification = this.FilesSettings.IsEmailNotification;
                */
                mediaBankFile.MediaBankFileSetting.CommentSettingType = this.FilesSettings.CommentSettingType;
                mediaBankFile.Url = '';
                mediaBankFile.AccessRightFilterCollection.InitializeAccessRightFilterCollection(
                    this.AccessRightFilterCollection,
                );

                if (!!this.SelectedTagsIds.length) mediaBankFile.TagIds = this.SelectedTagsIds;

                mediaBankFile.PublicationSetting = this.publicationSetting;

                if (mediaBankFile.$$uploadPogress) delete mediaBankFile.$$uploadPogress;
            });

            this.fiLoadingService
                .trackPromise(this.mediaBankService.SaveMediaBankFiles(mediaBankFilesToSave))
                .then(() => {
                    this.accessRightFilters.OnAccessRightFilterCollectionSaved();

                    this.saveChangesWarningService.stop();
                    if (this.stateService.params.closeIFrameAfterSave === 'true') {
                        this.mobileAppHelperService.reloadPriorityFeed();
                        this.mobileAppHelperService.closeIFrame();
                    } else {
                        this.stateService.go(FiStateNames.MediaBank.List);
                    }
                    this.showSnackbar(mediaBankFilesToSave[0].PublicationSetting.IsShared, mediaBankFilesToSave.length);
                });
        }
    }

    protected readonly ObjectTypes = ObjectTypes;
}
